import { keyframes } from '@mui/material/styles';

export const constructionAnimation = keyframes`
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 28px 28px;
  }
`;

export const initializeTheme = () => {
  if (typeof window !== 'undefined') {
    const isDark = localStorage.getItem('darkMode') === 'true';
    if (isDark && document.documentElement) {
      document.documentElement.style.backgroundColor = '#080808';
      if (document.body) {
        document.body.style.backgroundColor = '#080808';
      }
    }
  }
}; 